import React from "react";

const CourseList = ({ classes }) => {
  if (!classes || classes.length === 0) {
    return (
      <p style={{ color: "var(--muted)" }}>
        No courses available at this time.
      </p>
    );
  }

  return (
    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
      {classes.map((cls) => (
        <li
          key={cls.id}
          style={{
            marginBottom: "1.5rem",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
            paddingBottom: "1rem",
          }}
        >
          <strong
            style={{
              display: "block",
              color: "var(--gold)",
              fontFamily: "var(--font-head)",
              fontSize: "1.1rem",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            {cls.title}
          </strong>
          <p
            style={{
              color: "var(--text)",
              fontSize: "0.95rem",
              marginTop: "0.5rem",
              lineHeight: 1.6,
              opacity: 0.9,
            }}
          >
            {cls.description}
          </p>
        </li>
      ))}
    </ul>
  );
};

export default CourseList;
